const BASE_URL = "https://admin.pleyohub.com/api";

export const loginApi = async (identifier, password) => {
    const response = await fetch(`${BASE_URL}/auth/local`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier, password })
    });
    if (!response.ok) throw new Error('Login failed');
    return response.json();
};

export const fetchScores = async (jwt, startDate, endDate, page, pageSize = 100) => {
    const url = `${BASE_URL}/massive-multiplayers?populate=*&&sort=gameStartDate&filters[createdAt][$gt]=${startDate}&filters[createdAt][$lt]=${endDate}&pagination[pageSize]=${pageSize}&pagination[page]=${page}`;
    const response = await fetch(url, { headers: { Authorization: `Bearer ${jwt}` } });
    if (!response.ok) throw new Error(`Error fetching data on page ${page}`);
    return response.json();
};
